import React, { useEffect, useState } from 'react';
import { Eye, KeyRound, Loader2, ShieldCheck } from 'lucide-react';
import { apiCall } from '../../utils/api';

const ACTION_META = {
  'hris.document.download': { label: 'Opened', icon: Eye, cls: 'text-slate-600' },
  'hris.document.access_granted': { label: 'Requested access', icon: KeyRound, cls: 'text-amber-700' },
  'hris.document.reveal': { label: 'Revealed', icon: ShieldCheck, cls: 'text-indigo-700' },
};

// "Who has seen this worker's files" — audit trail of downloads + break-glass grants.
export function DocumentAccessLog({ workerId }) {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    apiCall(`/api/hris/admin/workers/${workerId}/access-log?limit=50`).then(d => setEvents(d.events || [])).catch(() => setEvents([]));
  }, [workerId]);
  return (
    <div className="border border-slate-200 rounded-xl p-3 bg-slate-50/60" data-testid="document-access-log">
      <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-semibold mb-2">Documents accessed</p>
      {events === null ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" />
        : events.length === 0 ? <p className="text-xs text-slate-400 italic">No one has opened this worker's files yet.</p>
        : (
          <ul className="space-y-1.5 max-h-56 overflow-y-auto">
            {events.map(e => {
              const m = ACTION_META[e.action] || ACTION_META['hris.document.download']; const Icon = m.icon;
              return (
                <li key={e._id} className="flex items-start gap-2 text-xs" data-testid={`access-event-${e._id}`}>
                  <Icon className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${m.cls}`} />
                  <div className="min-w-0 flex-1">
                    <p className="text-slate-800">
                      <span className="font-semibold">{e.actor_name || e.actor_id?.slice(-6) || 'Someone'}</span>
                      <span className="text-slate-500"> ({e.actor_role})</span> {m.label.toLowerCase()}
                      {e.file_name && <span className="font-medium"> {e.file_name}</span>}
                      {e.sensitivity === 'restricted' && <span className="ml-1 text-[10px] font-bold text-amber-700 uppercase">restricted</span>}
                    </p>
                    {e.reason && <p className="text-[11px] text-amber-800 italic">“{e.reason}”</p>}
                    <p className="text-[10px] text-slate-400">{new Date(e.created_at).toLocaleString()}{e.ip_address ? ` · ${e.ip_address}` : ''}{e.via ? ` · ${e.via} link` : ''}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
    </div>
  );
}
